var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      attrs: {
        data: _vm.list,
        "element-loading-text": "数据正在加载中...",
        border: "",
        stripe: "",
        fit: "",
        "highlight-current-row": "",
        "summary-method": _vm.getSummaries,
        "show-summary": ""
      }
    },
    [
      _c("el-table-column", {
        attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
      }),
      _c("el-table-column", { attrs: { prop: "name", label: "费用名称" } }),
      _c("el-table-column", { attrs: { prop: "price", label: "金额" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }